<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>操作日志</h2>
        <p>
          按人、时间、模块、类型查看 CRM
          操作记录，为后续审计、回溯和质检留好页面结构。
        </p>
      </div>
      <div class="crm-actions">
        <el-button icon="el-icon-download" @click="notifyPending"
          >导出日志（待开发）</el-button
        >
      </div>
    </div>

    <el-card shadow="never">
      <el-row :gutter="12">
        <el-col :span="6"
          ><el-input
            v-model.trim="filters.keyword"
            placeholder="操作人 / 客户姓名"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="6"
          ><el-input
            v-model.trim="filters.module"
            placeholder="操作模块"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="6"
          ><el-input
            v-model.trim="filters.type"
            placeholder="操作类型"
            clearable
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="filters.range"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-col>
      </el-row>
    </el-card>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>操作日志列表</span>
        <el-tag size="mini" type="info">{{ filteredLogs.length }} 条</el-tag>
      </div>
      <el-table :data="filteredLogs" stripe border>
        <el-table-column
          prop="time"
          label="操作时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="operator"
          label="操作人"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="module"
          label="操作模块"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="操作类型"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="content"
          label="操作内容"
          min-width="180"
        ></el-table-column>
        <el-table-column prop="result" label="结果" width="90">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.result === '成功' ? 'success' : 'danger'"
              >{{ scope.row.result }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="160"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { loadCrmState } from "./mock";

export default {
  name: "CrmLogs",
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      filters: { keyword: "", module: "", type: "", range: [] },
    };
  },
  computed: {
    filteredLogs() {
      return (this.state.operationLogs || []).filter((item) => {
        if (this.filters.keyword) {
          const text = `${item.operator}${item.customerName}`;
          if (text.indexOf(this.filters.keyword) === -1) return false;
        }
        if (
          this.filters.module &&
          item.module.indexOf(this.filters.module) === -1
        )
          return false;
        if (this.filters.type && item.type.indexOf(this.filters.type) === -1)
          return false;
        if (
          Array.isArray(this.filters.range) &&
          this.filters.range.length === 2
        ) {
          const date = String(item.time || "").slice(0, 10);
          if (date < this.filters.range[0] || date > this.filters.range[1])
            return false;
        }
        return true;
      });
    },
  },
  methods: {
    notifyPending() {
      this.$message.warning("日志导出为待开发功能，当前先确认日志字段结构。");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
